import React, { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Layout from "./Components/common/Layout";
// import Dashboard from "./Components/Dashboard";
// import Master from "./Pages/Master/Master";
// import Lead from "./Pages/Lead/LeadList";
// import Source from "./Pages/Source/Source";
import Login from "./Pages/Login/Login";
import { LoaderProvider } from "./Context/ContextFunctions";

const App = () => {
  const Dashboard = lazy(() => import("./Pages/Dashboard/Dashboard"));
  const Master = lazy(() => import("./Pages/Master/Master"));
  const Lead = lazy(() => import("./Pages/Lead/LeadList"));
  const Source = lazy(() => import("./Pages/Source/Source"));
  const EnquiryReceived = lazy(() =>
    import("./Pages/EnquiryRecevied/EnquiryReceivedList")
  );
  const ESTBoq = lazy(() => import("./Pages/ESTBOQ/EstBoqList"));
  const SalesLog = lazy(() => import("./Pages/SalesLog/SalesLogList"));
  const Invoice = lazy(() => import("./Pages/Invoice/InvoiceList"));
  const AccountLog = lazy(() => import("./Pages/AccountLog/AccountLogList"));
  const Followup = lazy(() => import("./Pages/Follow-up/FollowupList"));
  const Quotation = lazy(() => import("./Pages/Quotation/QuotationList"));
  const DVR = lazy(() => import("./Pages/DVR/DvrList"));
  const Profile = lazy(() => import("./Pages/Profile/Profile"));
  const DetailedLog = lazy(() =>
    import("./Pages/DetailedLogs/DetailedLeadLogs")
  );
  const PreViewQuotation = lazy(() =>
    import("./Pages/Quotation/PreViewQuotation")
  );
  const AddUpdateQuotation = lazy(() =>
    import("./Pages/Quotation/AddUpdateQuotation")
  );
  const PreViewPO = lazy(() =>
    import("./Components/common/POPreviewPage")
  );
  const POModal = lazy(() =>
    import("./Components/common/PoModal")
  );
  const PreviewInvoice = lazy(() =>
    import("./Pages/Invoice/PreviewInvoice")
  );
  const PreviewInvoiceReceipt = lazy(() =>
    import("./Pages/Invoice/PreviewInvoiceReceipt")
  );
  const TaskManagementList = lazy(() =>
    import("./Pages/TaskManagement/TaskManagementList")
  );
  const HelpRequestList = lazy(() =>
    import("./Pages/TaskManagement/HelpRequestList")
  );
  const NotesAndAttachments = lazy(() =>
    import("./Pages/TaskManagement/NotesAndAttachments")
  );

  return (
    <Router>
      <Layout>
        <Suspense fallback={<div>Loading...</div>}>
          <LoaderProvider>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/accountLog" element={<AccountLog />} />
              <Route path="/task-management" element={<TaskManagementList />} />
              <Route path="/help-requested-list" element={<HelpRequestList />} />
              <Route path="/notes-attachments-list" element={<NotesAndAttachments />} />
              <Route path="/dvr" element={<DVR />} />
              <Route path="/lead" element={<Lead />} />
              <Route path="/salesLog" element={<SalesLog />} />
              <Route path="/detailedLog" element={<DetailedLog />} />
              <Route path="/estBoq" element={<ESTBoq />} />
              <Route path="/invoice" element={<Invoice />} />
              <Route path="/login" element={<Login />} />
              <Route path="/enquiry-received" element={<EnquiryReceived />} />
              <Route path="/followup" element={<Followup />} />
              <Route path="/quotation" element={<Quotation />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/viewQuotation" element={<PreViewQuotation />} />
              <Route path="/previewPO" element={<PreViewPO />} />
              <Route path="/POModal" element={<POModal />} />
              <Route path="/previewInvoice" element={<PreviewInvoice />} />
              <Route path="/previewInvoiceReceipt" element={<PreviewInvoiceReceipt />} />
              <Route
                path="/addUpdateQuotation"
                element={<AddUpdateQuotation />}
              />
            </Routes>
          </LoaderProvider>
        </Suspense>
      </Layout>
    </Router>
  );
};

export default App;
